var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowUpRightGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72363 3.98592C4.73141 3.43369 5.18538 2.99232 5.73761 3.0001L12.42 3.09422C12.9612 3.10184 13.3982 3.53877 13.4058 4.08004L13.4999 10.7624C13.5077 11.3146 13.0663 11.7686 12.5141 11.7764C11.9619 11.7842 11.5079 11.3428 11.5001 10.7906L11.4393 6.4749L5.20711 12.7071C4.81658 13.0976 4.18342 13.0976 3.79289 12.7071C3.40237 12.3166 3.40237 11.6834 3.79289 11.2929L10.0251 5.06069L5.70945 4.9999C5.15722 4.99212 4.71585 4.53815 4.72363 3.98592Z",
    fill: "#B6BFCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpRightGrey);
export default __webpack_public_path__ + "static/media/ic-arrow-up-right-grey.1c7a1b9b50133b274002868557dec902.svg";
export { ForwardRef as ReactComponent };